<script lang="ts">
  let {
    title,
    body,
    actionLabel,
    onaction,
  }: {
    title: string;
    body: string;
    actionLabel?: string;
    onaction?: () => void;
  } = $props();
</script>

<div class="empty">
  <h2>{title}</h2>
  <p>{body}</p>
  {#if actionLabel !== undefined && onaction !== undefined}
    <button onclick={onaction}>{actionLabel}</button>
  {/if}
</div>

<style>
  .empty {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 32px;
    gap: 8px;
  }
  h2 {
    margin: 0;
    font-size: 20px;
  }
  p {
    margin: 0 0 12px;
    color: var(--ink-soft);
  }
  button {
    border: 0;
    border-radius: 999px;
    padding: 12px 28px;
    background: var(--brand);
    color: var(--brand-ink);
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
  }
</style>
